var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 121,
    viewBox: "0 0 201 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 25C43.9 25 51.9 28.3667 58.3 35.1C64.7667 41.8333 68 50.1333 68 60C68 69.8667 64.7667 78.1667 58.3 84.9C51.9 91.6333 43.9 95 34.3 95H6.5V25H34.3ZM34.3 81.8C40.3667 81.8 45.3 79.8 49.1 75.8C52.9 71.7333 54.8 66.4667 54.8 60C54.8 53.5333 52.9 48.3 49.1 44.3C45.3 40.2333 40.3667 38.2 34.3 38.2H20.3V81.8H34.3ZM136.689 85.9C129.622 92.9 121.022 96.4 110.889 96.4C100.756 96.4 92.1557 92.9 85.0891 85.9C78.0891 78.8333 74.5891 70.2 74.5891 60C74.5891 49.8 78.0891 41.2 85.0891 34.2C92.1557 27.1333 100.756 23.6 110.889 23.6C121.022 23.6 129.622 27.1333 136.689 34.2C143.756 41.2 147.289 49.8 147.289 60C147.289 70.2 143.756 78.8333 136.689 85.9ZM94.7891 76.5C99.1224 80.7667 104.489 82.9 110.889 82.9C117.289 82.9 122.656 80.7667 126.989 76.5C131.322 72.1667 133.489 66.6667 133.489 60C133.489 53.3333 131.322 47.8333 126.989 43.5C122.656 39.1667 117.289 37 110.889 37C104.489 37 99.1224 39.1667 94.7891 43.5C90.4557 47.8333 88.2891 53.3333 88.2891 60C88.2891 66.6667 90.4557 72.1667 94.7891 76.5ZM199.284 25V38.2H180.384V95H166.584V38.2H147.784V25H199.284Z",
    fill: "#1E253E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 90,
    r: 5,
    fill: "#38D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/Dot.c507a61040948422dfea20e4056a602a.svg";
export { ForwardRef as ReactComponent };